import { useMemo } from 'react';
import formatShowDatesAndAnchor from './formatShowDatesAndAnchor';

export const useShowData = (sanityNodes) => {
  const { shows } = useMemo(() => {
    return {
      shows: formatShowDatesAndAnchor(sanityNodes)
    }
  }, [sanityNodes])
  return [shows]
}